import { createStore } from './store-factory';
import { getFeatureAccessControls, FeatureAccessMap, FeatureAccess, placeholderData } from '../hooks/useFeatureAccessControls';

interface FeatureFlagState {
  isInitialized: boolean;
  isInitializing: boolean;
  featureFlags: FeatureAccessMap;
  initializeFeatureFlags: () => Promise<void>;
  hasFeatureAccess: (flag: FeatureAccess) => boolean;
}

export const useFeatureFlagStore = createStore<FeatureFlagState>('featureFlag', (set, get) => ({
  isInitialized: false,
  isInitializing: false,
  featureFlags: { ...placeholderData },

  initializeFeatureFlags: async () => {
    if (get().isInitializing || get().isInitialized) return;
    
    set({ isInitializing: true });
    const featureFlags = await getFeatureAccessControls();
    set({ featureFlags, isInitialized: true, isInitializing: false });
  },

  hasFeatureAccess: (flag: FeatureAccess): boolean => {
    const { featureFlags, isInitialized } = get();
    return isInitialized && featureFlags[flag] === true;
  },
}));
